import {
  checkCampaignFromMockRows
} from './new-rt-system.js'
import {
  filterRtDialogRows,
  matchesRtRowCondition,
  buildRtDialogInfo,
  resolveRtDialogType,
  hasDisplayableDetailInfo,
  hasValidLogoImage
} from './rt-dialog-migration'
import { useMedleyLinkResolver } from '@/composables/useMedleyLinkResolver'
import { loadDefaultJapaneseParser } from 'budoux'
import { emitGlobalVarPopupDialog } from './emitter'

const globalVar = {
  install: function (Vue, options) {
    const main = new Vue({
      data: function () {
        return {
          autoRTInfo: {
            logoImage: '',
            clientId: '',
            dialogName: '',
            clientName: '',
            termurl: '',
            privacyurl: '',
            occupationurl: '',
            clientServiceName: '',
            permissionType: 0,
            oldPermissionType: 0,
            googleConversationId: null,
            googleConversationLabel: null
          },
          qmailRirekishoHtml: '',
          deviceToken: '',
          dn_flag: 'dn',
          count_repeat: 0,
          isYagiPrime: false,
          isRecurrent: false,
          isAutoRTable: false,
          isAutoRT4Rtable: false,
          permissionType4RT: 0,
          oldPermissionType4RT: 0,
          isYagiPrimeCancel: false,
          isYagiPrimeQuickmailcount: 0,
          isShogai: false,
          in_app_payments: true,
          // Tier 1: 国家資格・専門免許（最優先）
          joblistKeywordTier1: [
            '施工管理', '看護師', '薬剤師', '作業療法士', '理学療法士', '言語聴覚士',
            '視能訓練士', '保育士', '歯科衛生士', '介護福祉士', '社会福祉士',
            '臨床検査技師', '管理栄養士', '栄養士', '歯科技工士', '電気工事士',
            '第二種電気工事士', '自動車整備士', '土木施工管理', 'MR', '養護教諭',
            '調理師', '通関士', '歯科助手'
          ],
          // Tier 2: 専門職種名
          joblistKeywordTier2: [
            'システムエンジニア', 'ITエンジニア', 'インフラエンジニア', 'Webマーケティング',
            'Webデザイナー', 'プログラマー', 'グラフィックデザイン', 'CAD製図',
            'CADオペレーター', '溶接', '鈑金塗装', 'フォークリフト',
            '訪問介護', '介護職', 'ヘルパー', '経理事務', '営業事務',
            '医療事務', '調剤薬局事務', 'ルート営業', '法人営業', '人材営業',
            'インサイドセールス', '医師', '弁護士', '獣医', '司書',
            '塾講師', '英会話講師', 'ダンスインストラクター',
            '施工管理アシスタント', '保育士補助', 'DTPオペレーター'
          ],
          // Tier 3: 業界・職種カテゴリ
          joblistKeywordTier3: [
            'IT', '医療', '介護', '建設', '不動産', '飲食業', '物流', '保険',
            '金融', '製造業', 'アパレル', 'ホテル', '旅行業界', '教育',
            '農業', '警備', '運輸', '電気工事', 'ゲーム業界', '鍼灸',
            '鮮魚', '軽作業', 'ピッキング', '梱包', '検品'
          ],
          // Tier 4: 汎用カテゴリ（フォールバック）
          joblistKeywordTier4: [
            '営業', '事務', '製造', 'エンジニア', 'ドライバー', '販売', '配送',
            '経理', '総務', '人事', '企画', '開発', '設計', '品質管理',
            'デザイン', '編集', '翻訳', 'コールセンター', '受付',
            'プログラミング', 'ライター', '調理', '清掃'
          ],
          joblistPrefs: ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県', '海外'],
          getMessageBoxresult: [],
          RecurrentWords: []
        }
      },
      computed: {
      },
      methods: {
        // OEM環境チェック
        isOemEnvironment: function () {
          try {
            if (Vue.prototype.$cookies) {
              const oemId = Vue.prototype.$cookies.get('_YAGISH_OEM_ID')
              if (oemId) return true
            }
          } catch (e) {
            console.warn('Cookie access error:', e)
          }
          try {
            if (Vue.prototype.$oemContext && !Vue.prototype.$oemContext.isOemEnabled()) {
              return true
            }
          } catch (e) {
            console.warn('oemContext access error:', e)
          }
          return false
        },
        initAutoRT: function () {
          this.isAutoRTable = false
          this.isAutoRT4Rtable = false
          // OEM環境の場合はRT機能を無効化
          if (this.isOemEnvironment()) {
            return
          }
        },
        is_BehindRT: function () {
          // ヤマト住建向けの判定
          try {
            const cookies = this.$cookies || (typeof Vue !== 'undefined' ? Vue.prototype.$cookies : null)
            if (!cookies) return false

            const flag = cookies.get('_YAGISH_ATHLETE_UNIVID')
            // undefined, nullの判定のため以下の様に返す
            return flag != null
          } catch (error) {
            console.error(error)
            return false
          }
        },
        isNewFormat: function (_id) {
          return this.targetNewIds.includes(_id)
        },
        isShokumukeirekiFormat: function (_id) {
          return _id.includes('shokumukeirekisho')
        },
        eventTag: function () {
          // alert('pdf_' + this.dn_flag + '_rt_completed')
          this.invokeNative('pdf_' + this.dn_flag + '_rt_completed')
        },
        invokeNative: function (_id) {
          console.error(_id)
          if (this.$site.appFlag == 'b' || true) {
            try {
              MessageInvoker.postMessage(_id)
            } catch (error) {
              console.warn(`Error occurred while calling postMessage: ${error.message}`)
            }
          }
        },
        getRecurrentSkillList: function (formatData) {
          if (!formatData) return []
          const collected = []
          const pushDescriptions = function (histories) {
            if (!histories) return
            const arr = Array.isArray(histories) ? histories : Object.values(histories)
            arr.forEach(function (item) {
              const s = item && item.description ? item.description.trim() : ''
              if (s !== '') collected.push(s)
            })
          }
          pushDescriptions(formatData.educationalHistories)
          pushDescriptions(formatData.jobHistories)
          pushDescriptions(formatData.licenseHistories)
          return collected.filter(function (s, i, self) { return self.indexOf(s) === i })
        },
        getCategoryKeyByRecurrentPermission: function (permissionType) {
          const map = { 1: 'kango', 2: 'kaigo', 3: 'rihabiri', 4: 'hoikushi' }
          return map[permissionType] || null
        },
        keywordCheckFormatOrShokumu: function (targetData, keywordlist) {
          if (!targetData) return false
          return this.keywordCheckRirekisho(targetData, keywordlist) || this.keywordCheckShokumukeirekisho(targetData, keywordlist)
        },
        getMatchedCanonicalSkillList: function (formatData, canonicalSkills) {
          if (!Array.isArray(canonicalSkills) || !formatData) return []
          const list = []
          for (let i = 0; i < canonicalSkills.length; i++) {
            const entry = canonicalSkills[i]
            if (entry && Array.isArray(entry.matchForms) && this.keywordCheckFormatOrShokumu(formatData, entry.matchForms)) {
              list.push(entry.canonical)
            }
          }
          // 同一 canonical が複数エントリでマッチした場合の重複を排除
          return list.filter(function (s, i, self) { return self.indexOf(s) === i })
        },
        keywordCheck: function (formatId, formatData, keyword) {
          let _check = false
          if (formatId == 'shokumukeirekisho') {
            return false
          }
          // 本人希望欄（最も明示的な希望記述）
          if (formatData.request && formatData.request.indexOf(keyword) >= 0) {
            _check = true
          }
          for (const key in formatData.educationalHistories) {
            // 見出し
            const item = formatData.educationalHistories[key]
            if (item.description && item.description.indexOf(keyword) >= 0) {
              _check = true
            }
          }
          for (const key in formatData.jobHistories) {
            // 見出し
            const item = formatData.jobHistories[key]
            if (item.description && item.description.indexOf(keyword) >= 0) {
              _check = true
            }
          }
          for (const key in formatData.licenseHistories) {
            // 見出し
            const item = formatData.licenseHistories[key]
            if (item.description && item.description.indexOf(keyword) >= 0) {
              _check = true
            }
          }
          return _check
        },
        keywordCheckOnlyLicense: function (formatId, formatData, keyword) {
          let _check = false
          if (formatId == 'shokumukeirekisho') {
            return false
          }
          for (const key in formatData.licenseHistories) {
            // 見出し
            const item = formatData.licenseHistories[key]
            if (item.description && item.description.indexOf(keyword) >= 0) {
              _check = true
            }
          }
          return _check
        },
        keywordCheck3: function (formatData, keyword) {
          let _check = false

          if (formatData.prMessage && formatData.prMessage.indexOf(keyword) >= 0) {
            _check = true
          }
          if (formatData.jobSummary && formatData.jobSummary.indexOf(keyword) >= 0) {
            _check = true
          }
          if (formatData.jobHistories) {
            for (const key in formatData.jobHistories) {
              // 見出し
              const item = formatData.jobHistories[key]
              if (item && item.businessArea && item.businessArea.indexOf(keyword) >= 0) {
                _check = true
              }
              if (item && item.projects) {
                for (const subkey in item.projects) {
                  const subitem = item.projects[subkey]
                  if (subitem && subitem.contentsOfProject && subitem.contentsOfProject.indexOf(keyword) >= 0) {
                    _check = true
                  }
                  if (subitem && subitem.projectTitle && subitem.projectTitle.indexOf(keyword) >= 0) {
                    _check = true
                  }
                  if (subitem && subitem.position && subitem.position.indexOf(keyword) >= 0) {
                    _check = true
                  }
                }
              }
            }
          }
          return _check
        },
        _keywordCheckRirekisho: function (targetData, keywordlist) {
          for (const keyword in keywordlist) {
            for (const key in targetData.educationalHistories) {
              // 見出し
              const item = targetData.educationalHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
            }
            for (const key in targetData.jobHistories) {
              // 見出し
              const item = targetData.jobHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
            }
            for (const key in targetData.licenseHistories) {
              // 見出し
              const item = targetData.licenseHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
            }
          }
          // targetData.reasonが存在しない場合はfalseを返す
          if (!targetData.reason || typeof targetData.reason !== 'string') {
            return false
          }
          const parser = loadDefaultJapaneseParser()
          const parsedText = parser.parse(targetData.reason)
          // parseの結果が配列でない場合はfalseを返す
          if (!Array.isArray(parsedText)) {
            return false
          }

          for (const textData in parsedText) {
            for (const keyword in keywordlist) {
              if (textData.includes(keyword)) {
                return true
              }
            }
          }
          return false
        },
        keywordCheckRirekisho: function (targetData, keywordlist) {
          for (const keyword in keywordlist) {
            for (const key in targetData.educationalHistories) {
              // 見出し
              const item = targetData.educationalHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
            }
            for (const key in targetData.jobHistories) {
              // 見出し
              const item = targetData.jobHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
            }
            for (const key in targetData.licenseHistories) {
              // 見出し
              const item = targetData.licenseHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
            }
          }
          return false
        },
        /**
         * RT 再表示チェーン（displayPopup4Repeat）用の「特定 KW 該当」判定。
         * keywordCheckRirekisho だけだと本人希望（request）にだけある場合が取りこぼされ、
         * 上限が 2 件のまま（4 件に伸びない）になる。keywordCheck や志望動機（reason）も見る。
         * @param {string} formatId
         * @param {object} [formatData] 履歴書フォーマット Data
         * @param {string[]} keywordlist
         * @param {object} [shokumuFromOther] otherFormatData 内の職務経歴書（マイページ等）
         */
        checkRepeatRTChainExtendedKeywords: function (formatId, formatData, keywordlist, shokumuFromOther) {
          if (!keywordlist || !keywordlist.length) return false
          if (formatData) {
            if (this.keywordCheckRirekisho(formatData, keywordlist)) return true
            if (this.keywordCheckShokumukeirekisho(formatData, keywordlist)) return true
            if (typeof formatData.reason === 'string' && formatData.reason) {
              for (let i = 0; i < keywordlist.length; i++) {
                if (formatData.reason.indexOf(keywordlist[i]) >= 0) return true
              }
            }
          }
          if (shokumuFromOther && typeof shokumuFromOther === 'object' && this.keywordCheckShokumukeirekisho(shokumuFromOther, keywordlist)) {
            return true
          }
          if (formatId && formatId !== 'shokumukeirekisho' && formatData) {
            for (let i = 0; i < keywordlist.length; i++) {
              if (this.keywordCheck(formatId, formatData, keywordlist[i])) return true
            }
          }
          return false
        },
        keywordCheckBizreach1: function (targetData, basicData) {
          // ビズリーチ送信条件を満たすかどうかを判断する
          // 各種パラメータvalidation
          try {
            // 各種パラメータvalidation
            if (!basicData.lastName || !basicData.firstName || !basicData.email || !basicData.birthYear || !basicData.birthMonth || !basicData.birthDay || !basicData.sex) {
              throw new Error('ユーザー情報が未設定です')
            }
            if (!basicData.postNumber || !basicData.address1 || !basicData.tel1 || !basicData.tel2 || !basicData.tel3) {
              throw new Error('住所・電話番号が未設定です')
            }

            // 職歴の確認
            if (targetData.jobHistories.length == 0) {
              throw new Error('職歴がありません')
            }

            // 学歴
            if (targetData.educationalHistories.length == 0) {
              throw new Error('学歴がありません')
            }

            // 年収・希望職種・希望業種 (希望年収は任意項目につき表示条件から除外)
            if (!targetData.nowNensyu || !basicData.kibouShokushuCd || !basicData.kibouGyoushuCd) {
              throw new Error('年収・希望職種・希望業種がありません')
            }
          } catch (error) {
            console.log(error)
            return false
          }
          return true
        },
        LegacyKeywordCheckRirekisho: function (targetData, keywordlist) {
          for (const keyword in keywordlist) {
            for (const key in targetData.educationalHistories) {
              // 見出し
              const item = targetData.educationalHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
            }
            for (const key in targetData.jobHistories) {
              // 見出し
              const item = targetData.jobHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
            }
            for (const key in targetData.licenseHistories) {
              // 見出し
              const item = targetData.licenseHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
            }
          }
          return false
        },
        keywordCheckShokumukeirekishoOnlyLicense: function (targetData, keyword) {
          if (targetData.skillsToUse) {
            for (const key in targetData.skillsToUse) {
              const item = targetData.skillsToUse[key]
              if (item && item.skillname && item.skillname.indexOf(keyword) >= 0) {
                return true
              }
            }
          }
          return false
        },
        _keywordCheckShokumukeirekisho: function (targetData, keywordlist) {
          for (const keyword in keywordlist) {
            if (targetData.prMessage && targetData.prMessage.indexOf(keywordlist[keyword]) >= 0) {
              return true
            }
            if (targetData.jobSummary && targetData.jobSummary.indexOf(keywordlist[keyword]) >= 0) {
              return true
            }
            if (targetData.skillsToUse) {
              for (const key in targetData.skillsToUse) {
                const item = targetData.skillsToUse[key]
                if (item && item.skillname && item.skillname.indexOf(keywordlist[keyword]) >= 0) {
                  return true
                }
              }
            }
            if (targetData.jobHistories) {
              for (const key in targetData.jobHistories) {
                // 見出し
                const item = targetData.jobHistories[key]
                if (item && item.businessArea && item.businessArea.indexOf(keywordlist[keyword]) >= 0) {
                  return true
                }
                for (const subkey in item.projects) {
                  const subitem = item.projects[subkey]
                  if (subitem && subitem.contentsOfProject && subitem.contentsOfProject.indexOf(keywordlist[keyword]) >= 0) {
                    return true
                  }
                  if (subitem && subitem.projectTitle && subitem.projectTitle.indexOf(keywordlist[keyword]) >= 0) {
                    return true
                  }
                  if (subitem && subitem.position && subitem.position.indexOf(keywordlist[keyword]) >= 0) {
                    return true
                  }
                }
              }
            }
          }

          const parser = loadDefaultJapaneseParser()
          const text = [targetData.prMessage || '', targetData.jobSummary || ''].join(' ').trim()
          // テキストが空の場合はfalseを返す
          if (!text) {
            return false
          }
          const parsedText = parser.parse(text)
          // parseの結果が配列でない場合はfalseを返す
          if (!Array.isArray(parsedText)) {
            return false
          }

          for (const textData in parsedText) {
            for (const keyword in keywordlist) {
              if (textData.includes(keyword)) {
                return true
              }
            }
          }
          return false
        },
        keywordCheckShokumukeirekisho: function (targetData, keywordlist) {
          for (const keyword in keywordlist) {
            if (targetData.prMessage && targetData.prMessage.indexOf(keywordlist[keyword]) >= 0) {
              return true
            }
            if (targetData.jobSummary && targetData.jobSummary.indexOf(keywordlist[keyword]) >= 0) {
              return true
            }
            if (targetData.skillsToUse) {
              for (const key in targetData.skillsToUse) {
                const item = targetData.skillsToUse[key]
                if (item && item.skillname && item.skillname.indexOf(keywordlist[keyword]) >= 0) {
                  return true
                }
              }
            }
            if (targetData.jobHistories) {
              for (const key in targetData.jobHistories) {
                // 見出し
                const item = targetData.jobHistories[key]
                if (item && item.businessArea && item.businessArea.indexOf(keywordlist[keyword]) >= 0) {
                  return true
                }
                for (const subkey in item.projects) {
                  const subitem = item.projects[subkey]
                  if (subitem && subitem.contentsOfProject && subitem.contentsOfProject.indexOf(keywordlist[keyword]) >= 0) {
                    return true
                  }
                  if (subitem && subitem.projectTitle && subitem.projectTitle.indexOf(keywordlist[keyword]) >= 0) {
                    return true
                  }
                  if (subitem && subitem.position && subitem.position.indexOf(keywordlist[keyword]) >= 0) {
                    return true
                  }
                }
              }
            }
          }
          return false
        },
        LegacyKeywordCheckShokumukeirekisho: function (targetData, keywordlist) {
          for (const keyword in keywordlist) {
            if (targetData.prMessage && targetData.prMessage.indexOf(keywordlist[keyword]) >= 0) {
              return true
            }
            if (targetData.jobSummary && targetData.jobSummary.indexOf(keywordlist[keyword]) >= 0) {
              return true
            }
            if (targetData.skillsToUse) {
              for (const key in targetData.skillsToUse) {
                const item = targetData.skillsToUse[key]
                if (item && item.skillname && item.skillname.indexOf(keywordlist[keyword]) >= 0) {
                  return true
                }
              }
            }
            if (targetData.jobHistories) {
              for (const key in targetData.jobHistories) {
                // 見出し
                const item = targetData.jobHistories[key]
                if (item && item.businessArea && item.businessArea.indexOf(keywordlist[keyword]) >= 0) {
                  return true
                }
                for (const subkey in item.projects) {
                  const subitem = item.projects[subkey]
                  if (subitem && subitem.contentsOfProject && subitem.contentsOfProject.indexOf(keywordlist[keyword]) >= 0) {
                    return true
                  }
                  if (subitem && subitem.projectTitle && subitem.projectTitle.indexOf(keywordlist[keyword]) >= 0) {
                    return true
                  }
                  if (subitem && subitem.position && subitem.position.indexOf(keywordlist[keyword]) >= 0) {
                    return true
                  }
                }
              }
            }
          }
          return false
        },
        checkJoblistKeyword: function (formatId, formatData) {
          const isShokumu = (formatId === 'shokumukeirekisho')
          const tiers = [
            this.joblistKeywordTier1,
            this.joblistKeywordTier2,
            this.joblistKeywordTier3,
            this.joblistKeywordTier4
          ]

          // Step 0: 希望職種ドロップダウン（hopeJobcategory）が設定されていれば逆方向マッチ
          // JIS規格では未設定だが、AI履歴書・新書式では設定される
          const hopeJob = formatData.hopeJobcategory
          if (hopeJob) {
            const hopeStr = Array.isArray(hopeJob) ? hopeJob.join('') : hopeJob
            for (let t = 0; t < tiers.length; t++) {
              for (let i = 0; i < tiers[t].length; i++) {
                if (hopeStr.indexOf(tiers[t][i]) >= 0) return tiers[t][i]
              }
            }
          }

          // Step 1: request（本人希望欄）/ description 等をスキャン
          for (let t = 0; t < tiers.length; t++) {
            const tier = tiers[t]
            for (let i = 0; i < tier.length; i++) {
              const keyword = tier[i]
              const hit = isShokumu
                ? this.keywordCheck3(formatData, keyword)
                : this.keywordCheck(formatId, formatData, keyword)
              if (hit) return keyword
            }
          }
          return ''
        },
        getPrefJoblist: function (basicData) {
          let _pref = ''
          for (const key in this.joblistPrefs) {
            if (basicData.address1.indexOf(this.joblistPrefs[key]) >= 0) {
              _pref = this.joblistPrefs[key]
            }
          }
          return _pref
        },
        addressCheck: function (basicData, addresslist) {
          for (const key in addresslist) {
            if (basicData.address1 && basicData.address1.indexOf(addresslist[key]) >= 0) {
              return true
            }
          }
          return false
        },
        /**
         * auto-rt バナー表示済みのとき、同一クライアント・oldPermission（または NewOnly 時は新 permission）に対応する
         * フロント RT ポップアップ（displayFrontEndPopupRenew）を出さない。
         */
        shouldSuppressRtPopupForAutoRT: function (rd) {
          if (!this.isAutoRTable || !this.autoRTInfo || !this.autoRTInfo.clientId) return false
          if (rd.client_id !== this.autoRTInfo.clientId) return false
          const pt = Number(rd.permission_type)
          const oldPt = this.autoRTInfo.oldPermissionType
          if (oldPt != null && oldPt !== 0) {
            return pt === Number(oldPt)
          }
          // oldPermission を明示していない NewOnly の場合は同一クライアントのポップアップを全て抑制
          return true
        },

        displayFrontEndPopupRenew: function (formatId, formatData, basicData, otherFormatData, request_data, previewFormat, isMypage = false) {
          if (this.is_BehindRT && this.is_BehindRT()) {
            return false
          }

          if (formatId == 'rirekisho_esf_challenged') {
            return false
          }
          // ① 氏名チェック（どちらかがあればOK）
          const hasName = !!basicData.lastName || !!basicData.firstName

          // ② 電話番号チェック（全ての桁に値があり、数字のみ）
          const tel = [basicData.tel1, basicData.tel2, basicData.tel3].join('')
          const isTelValid = basicData.tel1 && basicData.tel2 && basicData.tel3 && /^[0-9０-９]+$/.test(tel)

          // ③ 生年月日チェック（birthYear が4桁）
          const isBirthYearValid = /^[0-9]{4}$/.test(basicData.birthYear)

          // 最終判定：すべてOKなら true、それ以外は false
          if (hasName && isTelValid && isBirthYearValid) {
            console.error('RT対象外')
          } else {
            return false
          }

          const rtConditionRows = Array.isArray(request_data)
            ? request_data
            : (request_data && typeof request_data === 'object' ? Object.values(request_data) : [])
          const rtConditionMap = new Map()
          for (const row of rtConditionRows) {
            if (!row) continue
            const key = `${row.client_id}:${Number(row.permission_type)}`
            // 同一 client_id + permission_type の重複行が混在するため、
            // 1件目固定ではなく「request_able が1件でも true なら表示可」で集約する。
            const current = rtConditionMap.get(key)
            const rowEnabled = row.request_able !== false
            rtConditionMap.set(key, (current === true) || rowEnabled)
          }
          const isRtConditionEnabled = (clientId, permissionType) => {
            const key = `${clientId}:${Number(permissionType)}`
            const enabled = rtConditionMap.get(key)
            // getDisableRtCondition のレスポンスに行が無い場合は「未制限」とみなす。
            // ここを false 扱いにすると else-if 連鎖で分岐だけ消費され、後続候補(workgate含む)まで進めなくなる。
            const result = enabled == null ? true : enabled === true
            console.log('[RT_TRACE] condition-check', { clientId, permissionType, key, enabled, result })
            return result
          }
          const emitRtPopupDialog = (...args) => {
            const permissionType = args[3]
            const dialogInfo = args[4]
            const isNewRtSystemDialog = Boolean(
              dialogInfo &&
              (dialogInfo.sendApiEndpointKey === 'sendNewRtSystem' || dialogInfo.conditionId)
            )
            if (!dialogInfo || (!dialogInfo.clientId && !isNewRtSystemDialog)) {
              return false
            }
            const enabled = isNewRtSystemDialog
              ? true
              : isRtConditionEnabled(dialogInfo.clientId, permissionType)
            if (!enabled) {
              return false
            }
            emitGlobalVarPopupDialog(...args)
            return true
          }

          // auto_rt を除いた RT ダイアログ行のコピー（バックエンド配列順を保持）
          const rtDialogRows = filterRtDialogRows(rtConditionRows)

          // 表示判定（条件配列）用コンテキスト。純粋ロジックは rt-dialog-migration.ts に集約。
          const rtConditionContext = {
            formatId,
            formatData,
            basicData,
            addressCheck: (bd, prefectures) => this.addressCheck(bd, prefectures),
            keywordCheckRirekisho: (fd, keywords) => this.keywordCheckRirekisho(fd, keywords),
            keywordCheckShokumukeirekisho: (fd, keywords) => this.keywordCheckShokumukeirekisho(fd, keywords),
            keywordCheckOnlyLicense: (fid, fd, keyword) => this.keywordCheckOnlyLicense(fid, fd, keyword)
          }

          // バックエンド配列を順に走査し、移行済みダイアログを detail_info から組み立てて発火する。
          const tryEmitMigratedRtDialog = () => {
            for (const row of rtDialogRows) {
              // request_able === false の行はバックエンド制限（check_flag 等）により送客不可。
              if (row.request_able === false) continue
              // auto_rt バナー表示済みのとき、同一クライアント・旧 permission の RT 1.0 は抑制する（isRoxx13 等と同じ挙動）。
              if (this.shouldSuppressRtPopupForAutoRT(row)) continue
              // 空 detail_info（API が display_flag !== '1' 等で非表示返し）はスキップ。
              if (!hasDisplayableDetailInfo(row)) continue
              if (!matchesRtRowCondition(row, rtConditionContext)) continue
              const dialogInfo = buildRtDialogInfo(row)
              if (Array.isArray(dialogInfo.MedlayLinkKey)) {
                const { resolveMedlayLinkKey } = useMedleyLinkResolver()
                const medlayUrls = resolveMedlayLinkKey({
                  medlayLinkKey: dialogInfo.MedlayLinkKey,
                  isMobile: this.$deviceLib.isMobileDevice === 'SP',
                  keywordCheckRirekisho: (fd, kws) => this.keywordCheckRirekisho(fd, kws),
                  keywordCheckShokumukeirekisho: (fd, kws) => this.keywordCheckShokumukeirekisho(fd, kws),
                  formatData
                })
                if (medlayUrls) {
                  dialogInfo.tabLinkUrl = medlayUrls.tabLinkUrl
                  dialogInfo.tabLinkUrlSp = medlayUrls.tabLinkUrlSp
                }
              }
              // ロゴ画像が空/不正（ファイル名なし）の行は表示崩れになるためスキップ。
              if (!hasValidLogoImage(dialogInfo.logoImage)) continue
              const dialogType = resolveRtDialogType(row)
              // additional_dialog_info.ButtonSizeUp はダイアログの第8引数(sizeUp)として渡す。
              const isButtonSizeUp = dialogInfo.ButtonSizeUp === true
              // emitRtPopupDialog が内部で request_able(isRtConditionEnabled) を判定する。
              if (emitRtPopupDialog(dialogType, formatId, previewFormat, Number(row.permission_type), dialogInfo, basicData, isMypage, isButtonSizeUp)) {
                // RecurrentValid 行: additional_dialog_info.canonicalSkills からユーザーの資格名リストを設定する。
                if (dialogInfo.RecurrentValid === true && Array.isArray(dialogInfo.canonicalSkills)) {
                  this.RecurrentWords = this.getMatchedCanonicalSkillList(formatData, dialogInfo.canonicalSkills)
                }
                return true
              }
            }
            return false
          }

          const nowdate3 = new Date()
          console.error(nowdate3)
          if (tryEmitMigratedRtDialog()) {
            // 移行済みダイアログ（jobs919_mail:5 / xmile_mail:28）はバックエンド依存で確定。
            // 以降のレガシー分岐は評価しない。
            // 以下に対応するMultirangeの設定をする必要がある
            // if ((basicData.age >= 25 && basicData.age <= 35) || (basicData.age >= 40 && basicData.age <= 55))
            // リカレントAPIに関しては{"ApiEndpointKey": "sendRecurrent"}様に一般的な呼び出し方に改修する必要がある
            // SKILL_CATEGORY_RULESもadditional_dialog_infoから取る形式に変更
          } else {
            let didEmitNewRt = false
            const checkrslt = checkCampaignFromMockRows(request_data, {
              basicData,
              formatData,
              addressCheck: this.addressCheck,
              keywordCheckRirekisho: this.keywordCheckRirekisho,
              formatId
            })
            for (const val in checkrslt) {
              if (checkrslt[val].is_web_app && checkrslt[val].check_result && checkrslt[val].request_able) {
                // eslint-disable-next-line camelcase
                const conditionId = request_data[val].detail_info.condition_id
                const dialogInfo = {
                  conditionId,
                  sendApiEndpointKey: 'sendNewRtSystem'
                }
                didEmitNewRt = emitRtPopupDialog('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData, isMypage)
                if (didEmitNewRt) {
                  break
                }
              }
            }
            if (!didEmitNewRt) {
              // ワークゲート求人ポップアップを表示（キーワード・エリア連携）
              const wgKeyword = this.checkJoblistKeyword(formatId, formatData)
              const wgArea = this.getPrefJoblist(basicData)
              emitGlobalVarPopupDialog('open-workgate-popup-dialog', formatId, previewFormat, basicData, wgKeyword, wgArea)
            }
          }
        }
      }
    })
    Vue.prototype.$globalVar = main
  }
}
export default globalVar
